module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filters"
  }, [_c('div', {
    staticClass: "filters__mobile"
  }, [_c('button', {
    staticClass: "filters__mobile--button",
    on: {
      "click": function($event) {
        _vm.toggleFilters()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.filters.choose))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "filters__box"
  }, [_c('div', {
    staticClass: "filters__box__content",
    class: {
      'filters__box--active': _vm.isActiveFilters
    }
  }, [_c('div', {
    staticClass: "filters__box__close"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.toggleFilters()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.filters.close))])]), _vm._v(" "), _c('div', {
    staticClass: "filters__box__list"
  }, [_c('div', {
    staticClass: "filters__box__title"
  }, [_c('h3', {
    staticClass: "filters__box__header"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.filters.choose) + "\n          ")])]), _vm._v(" "), _c("search-filter", {
    tag: "div",
    staticClass: "filters__item filters__item--language filter",
    attrs: {
      "name": "language",
      "values": _vm.filtersFields.language
    }
  }), _vm._v(" "), _c("search-filter", {
    tag: "div",
    staticClass: "filters__item filters__item--data-provider filter",
    attrs: {
      "name": "data_provider",
      "values": _vm.filtersFields.data_provider
    }
  }), _vm._v(" "), _c("search-filter", {
    tag: "div",
    staticClass: "filters__item filters__item--place-of-publishing filter",
    attrs: {
      "name": "place_of_publishing",
      "values": _vm.filtersFields.place_of_publishing
    }
  }), _vm._v(" "), _c("search-date-filter", {
    tag: "div",
    staticClass: "filters__item filters__item--date filter"
  }), _vm._v(" "), _c('div', {
    staticClass: "filters__bottom filters__box__clear"
  }, [(_vm.isFiltersSet || _vm.isDateSet) ? _c('button', {
    staticClass: "filters__bottom--clear",
    on: {
      "click": function($event) {
        _vm.resetFilters()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.filters.clear_all) + "\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "filters__bottom"
  }, [(_vm.isFiltersSet || _vm.isDateSet) ? _c('button', {
    staticClass: "filters__bottom--clear",
    on: {
      "click": function($event) {
        _vm.resetFilters()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.filters.clear_all) + "\n      ")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter__header--icon"
  }, [_c('i')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-626e6ab6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/SearchFilters.vue
// module id = 341
// module chunks = 1